// extracted by mini-css-extract-plugin
export default {"stateContainer":"StateContainer_stateContainer__lOtNa","icon":"StateContainer_icon__uZIwN","iconLarge":"StateContainer_iconLarge__tWzMo","title":"StateContainer_title__TEvuC"};